import React, { Component } from 'react';
import { withTranslation, TFunction } from 'react-i18next';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import Location from '@solvhealth/types/interfaces/Location';
import { LinkButton } from '../SolvPatternLibrary/Button/BaseButton';
import { ButtonVariations } from '../SolvPatternLibrary/Button';
import { colors } from '../../constants/colors';
import InsuranceCard from './InsuranceCard';
import FileUpload from '../SolvPatternLibrary/FileUpload';
import { ImageType } from '../../sagas/images';
import { isPhotoOnlyInsuranceFlow } from '../../core/util/location';
import MainCtaButton from './components/MainCtaButton';
import { OriginType } from '../../core/util/bookingFlowRoutingTypes';
import { getAddInsuranceActions, AddInsuranceActions } from '~/routes/addInsurance';
import InsuranceCardShape from '../../shapes/InsuranceCard';

const FRONT_SCANNING = 'frontScanning';

const UploadAndScanButton = styled(LinkButton)`
  margin-left: auto;
  margin-right: auto;
`;

const InfoMessage = styled.div`
  margin-top: 20px;
  color: ${colors.blueMonday};
`;

const ScanInsuranceCTA = styled.div`
  text-align: center;
`;

const FileInput = styled(FileUpload)`
  position: absolute;
  width: 160px;
  top: 0;
  left: 0;
  opacity: 0.01;
  border: none;
  z-index: 1;
  cursor: pointer;
  height: 38px;
  font-size: 0;
`;

const ScanButtonContainer = styled.span`
  position: relative;
  width: 170px;
  margin: auto;
`;

const StyledCardContainer = styled(Grid)`
  display: flex;
  justify-content: space-evenly;
`;

const StyledGrid = styled(Grid)`
  width: 100%;
`;

type Props = {
  // @ts-expect-error ts-migrate(2749) FIXME: 'InsuranceCardShape' refers to a value, but is bei... Remove this comment to see the full error message
  insuranceCard?: InsuranceCardShape;
  handleFileChange: (
    imageType: ImageType,
    location: Location,
    afterChangeActions: AddInsuranceActions
  ) => any;
  handleSkip: () => void;
  location: Location;
  onClickFront?: (...args: any[]) => any;
  onClickBack?: (...args: any[]) => any;
  origin: OriginType;
  t: TFunction<'addInsurance'>;
  isSRPorCDP?: boolean;
};

class InsuranceFileUpload extends Component<Props> {
  render = () => {
    let view;
    const {
      insuranceCard,
      handleFileChange,
      handleSkip,
      location,
      onClickFront,
      onClickBack,
      origin,
      t,
    } = this.props;

    const isMobileFlow = false;
    const isInsuranceFormPage = true;

    if (insuranceCard.front.scanStarted) {
      view = FRONT_SCANNING;
    }

    if (view === FRONT_SCANNING || isPhotoOnlyInsuranceFlow(location)) {
      return (
        <>
          <StyledCardContainer
            item
            style={{ columnGap: this.props.isSRPorCDP ? '80px' : '0' }}
            xs={12}
          >
            <InsuranceCard
              cardImage={insuranceCard.front.base64}
              handleFileChange={handleFileChange(
                ImageType.HealthInsuranceFront,
                location,
                getAddInsuranceActions(ImageType.HealthInsuranceFront)
              )}
              isSRPorCDP={this.props.isSRPorCDP}
              onClick={onClickFront}
              placeholderImage="/images/insurance/front_copy.svg"
              scanCompleted={insuranceCard.front.scanCompleted}
              scanStarted={insuranceCard.front.scanStarted}
              showPlaceholder={isPhotoOnlyInsuranceFlow(location)}
            >
              {t('insuranceFileUpload.addFrontOfCard')}
            </InsuranceCard>
            {(insuranceCard.front.scanStarted || isPhotoOnlyInsuranceFlow(location)) && (
              <InsuranceCard
                buttonStyle={ButtonVariations.tertiary}
                cardImage={insuranceCard.back.base64}
                handleFileChange={handleFileChange(
                  ImageType.HealthInsuranceBack,
                  location,
                  getAddInsuranceActions(ImageType.HealthInsuranceBack)
                )}
                isSRPorCDP={this.props.isSRPorCDP}
                onClick={onClickBack}
                placeholderImage="/images/insurance/back_copy.svg"
                scanCompleted={insuranceCard.back.scanCompleted}
                scanStarted={insuranceCard.back.scanStarted}
                showPlaceholder
              >
                {t('insuranceFileUpload.addBackOfCard')}
              </InsuranceCard>
            )}
          </StyledCardContainer>
          {isPhotoOnlyInsuranceFlow(location) && (
            <MainCtaButton
              handleSkipInsurance={handleSkip}
              insuranceCard={insuranceCard}
              isInsuranceFormPage={isInsuranceFormPage}
              isMobileFlow={isMobileFlow}
              location={location}
              origin={origin}
            />
          )}
        </>
      );
    }
    return (
      <StyledGrid container justify="center" spacing={3}>
        <Grid item xs={12}>
          <ScanInsuranceCTA>
            <InfoMessage>{t('insuranceFileUpload.haveCardPhotoFront')}</InfoMessage>

            <ScanButtonContainer>
              <FileInput
                accept={'image/*'}
                onChange={handleFileChange(
                  ImageType.HealthInsuranceFront,
                  location,
                  getAddInsuranceActions(ImageType.HealthInsuranceFront)
                )}
                type="file"
              />

              <UploadAndScanButton disableRipple>
                {t('insuranceFileUpload.uploadImage')}
              </UploadAndScanButton>
            </ScanButtonContainer>
          </ScanInsuranceCTA>
        </Grid>
      </StyledGrid>
    );
  };
}

export default withTranslation('addInsurance')(InsuranceFileUpload);
